/**
 * CMMD's bootstrap read: the signed-in identity, membership list, and
 * `activeWorkspace`.
 *
 * Without an explicit `organizationId`, CMMD answers `activeWorkspace` with
 * its own default-organization guess rather than a confirmed fact -- the
 * proxy nulls that field out rather than forward it (forge#3636). Pass the
 * caller's known workspace, typically `getCurrentForgeWorkspaceId()`,
 * whenever one is confirmed.
 *
 * @module environments/cmmdApi/bootstrap
 */
import type { CmmdBootstrapData } from "@cmmd-forge/contracts";

import { request, type TransportConfig } from "./transport";

export interface BootstrapReadInput {
  readonly organizationId?: number;
}

export function fetchBootstrap(
  cfg: TransportConfig,
  input?: BootstrapReadInput,
): Promise<CmmdBootstrapData> {
  return request<CmmdBootstrapData>(
    {
      method: "GET",
      path: "/api/cmmd/bootstrap",
      ...(input?.organizationId !== undefined ? { query: { orgId: input.organizationId } } : {}),
    },
    cfg,
  );
}
